import { isRowAdBannerApiType } from '../epg/rowAd/rowAdBannerTypes';

const HOME_BANNER_API_TYPE = 'home-banner';
const TOAST_BANNER_API_TYPE = 'toast-banner';

/**
 * @param {unknown} payload
 * @param {(type: unknown) => boolean} matchesType
 * @returns {string[]}
 */
function extractElementIdsByType(payload, matchesType) {
  const { elements } = payload ?? {};
  if (!Array.isArray(elements)) {
    return [];
  }
  return elements
    .filter((el) => (
      el
      && matchesType(el?.type)
      && el?.elementId != null
      && String(el?.elementId).trim()
    ))
    .map((el) => String(el?.elementId).trim());
}

/**
 * @param {unknown} payload
 * @returns {string[]}
 */
export function extractRowAdsBannerIds(payload) {
  return extractElementIdsByType(payload, isRowAdBannerApiType);
}

/**
 * @param {unknown} payload
 * @returns {string[]}
 */
export function extractHomeBannerIds(payload) {
  return extractElementIdsByType(payload, (type) => type === HOME_BANNER_API_TYPE);
}

/**
 * @param {unknown} payload
 * @returns {string[]}
 */
export function extractToastBannerIds(payload) {
  return extractElementIdsByType(payload, (type) => type === TOAST_BANNER_API_TYPE);
}
